import React from "react";
import Add from "../../components/_payments/Add/Add";
import Cards from "../../containers/_payments/Cards/Cards";
import leftArrow from "../../assets/leftArrow.svg";
import Layout from "../../shared/Layout/Layout";
import styles from "./Payments.module.scss";
import { useNavigate } from "react-router-dom";

const Payments = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Payments</h1>

          <Cards />

          <Add />

          <button onClick={() => navigate("/success")}>Pay - $29</button>
        </div>
      </div>
    </Layout>
  );
};

export default Payments;
